import { useEffect } from "react";
import {
  Item,
  ItemContent,
  ItemHeader,
  ItemDescription,
  ItemExtra,
  Icon,
  Form,
  FormGroup,
  FormField,
} from "semantic-ui-react";
import HotelsDropDown from "@components/shared/HotelsDropDown";
import { useTextResources } from "@/language";
import CheckBoxToggle from "@components/shared/CheckBoxToggle";
import { Hotels } from "@/api/services/next";
import { useLoader } from "@hooks/useLoader";
import { onError } from "@components/shared/messages";

const CopySettings = ({ state, setState }) => {
  const text = useTextResources();
  const loader = useLoader();

  useEffect(() => {
    if (!state.SourceCopyRate?.HotelName && state.SourceCopyRate?.HotelId) {
      loader(true);
      Hotels.GetHotels({ Ids: [state.SourceCopyRate.HotelId] })
        .then((hotels) => {
          setState((prev) => ({
            ...prev,
            SourceCopyRate: {
              ...prev.SourceCopyRate,
              HotelName: hotels[0]?.Name || '',
            },
          }));
        })
        .catch((error) => {
          onError(error);
        })
        .finally(() => {
          loader(false);
        });
    }
  }, [state.SourceCopyRate?.HotelId, state.SourceCopyRate?.HotelName, setState, loader]);

  return (
    <Form>
      <Item
        style={{
          border: "1px solid #ddd",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <ItemContent>
          <ItemHeader as="a">
            <Icon name="building" />
            {text("SourcePriceList")}
          </ItemHeader>
          <ItemDescription>{state.SourceCopyRate.Name}</ItemDescription>
          <ItemExtra>Hotel: {state.SourceCopyRate.HotelName}</ItemExtra>
        </ItemContent>
      </Item>
      <FormGroup widths="equal" style={{ marginTop: "20px" }}>
        <FormField
          label={text("TargetHotels")}
          placeholder={text("SelectHotels")}
          multiple
          value={state.TargetHotelIds || []}
          onChange={(value) =>
            setState((prev) => ({
              ...prev,
              TargetHotelIds: value,
              RateCustomNames: value.map((id) => ({
                HotelId: id,
                RateName: state.SourceCopyRate.Name,
                IsNameValid: null,
              })),
            }))
          }
          control={HotelsDropDown}
        />
      </FormGroup>
      <div className="checkbox-wrapper">
        <div>
          <Icon name="setting" />
          {text("General")}
        </div>
        <CheckBoxToggle
          checked={state.Components.General || false}
          onClick={() =>
            setState((prev) => ({
              ...prev,
              Components: {
                ...prev.Components,
                General: !prev.Components.General,
              },
            }))
          }
        />
      </div>
      <div className="checkbox-wrapper">
        <div>
          <Icon name="dollar sign" />
          {text("Pricing")}
        </div>
        <CheckBoxToggle
          checked={state.Components.Pricing || false}
          onClick={() =>
            setState((prev) => ({
              ...prev,
              Components: {
                ...prev.Components,
                Pricing: !prev.Components.Pricing,
              },
            }))
          }
        />
      </div>
      <div className="checkbox-wrapper">
        <div>
          <Icon name="users" />
          {text("Assignments")}
        </div>
        <CheckBoxToggle
          checked={state.Components.Assignments || false}
          onClick={() =>
            setState((prev) => ({
              ...prev,
              Components: {
                ...prev.Components,
                Assignments: !prev.Components.Assignments,
              },
            }))
          }
        />
      </div>
      <div className="checkbox-wrapper">
        <div>
          <Icon name="file text outline" />
          {text("Content")}
        </div>
        <CheckBoxToggle
          checked={state.Components.Content || false}
          onClick={() =>
            setState((prev) => ({
              ...prev,
              Components: {
                ...prev.Components,
                Content: !prev.Components.Content,
              },
            }))
          }
        />
      </div>
    </Form>
  );
};

export default CopySettings;
